import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppService } from './app.service';
import { of } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Injectable({ providedIn: 'root' })
export class ExemptionFilingRequestService extends AppService {
  constructor(
    public http: HttpClient, 
    @Inject('environment') environment: any
  ) {
    super(http, environment);
  }
  ///

  getExemptionFilingRequestDetail(id: number, isFilling = false) {
    if (isFilling) {
      return this.http.get<any>(
        this.getEndpoint(`ExemptionFilingDetail/${id}`),
        this.gethttpOptions()
      );
    }
    return this.http.get<any>(
      this.getEndpoint(`ExemptionFilingRequestDetail/${id}`),
      this.gethttpOptions()
    );
  }

  addExistingExemptionFilingRequest(
    registrationControl: any,
    requestTypeId: number
  ) {
    var userId = this.getUser().userId;
    return this.http.get<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic?RegistrationControlNumber=${registrationControl}&RequestTypeId=${requestTypeId}`
      ),
      this.gethttpOptions()
    );
  }

  getExistingExemptionFilingRequest(
    registrationControl: any
  ) {
    var userId = this.getUser().userId;
    return this.http.get<any>(
      this.getEndpoint(
        `ExemptionFilingBasic?RegistrationControlNumber=${registrationControl}`
      ),
      this.gethttpOptions()
    );
  }

  addToExistingExemptionFilingRequest(exemptionFilingId: any, requestTypeId: number) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/RequestType?userId=${userId}`
      ),
      `{ "exemptionFilingId": ${exemptionFilingId}, "exemptionRequestType": ${requestTypeId}}`,
      this.gethttpOptions()
    );
  }

  addExemptionFilingRequest(requestTypeId: number) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/RequestType?userId=${userId}`
      ),
      `{ "exemptionRequestType": ${requestTypeId}}`,
      this.gethttpOptions()
    );
  }

  updateRequestStatus(requestTypeId: number, externalStatusTypeId: any, internalstatus: any, data: any, isFilling = false, isfinalApproval = false) {
    var userId = this.getUser().userId;
    console.log(userId);
    console.log(isFilling);
    console.log(externalStatusTypeId);
    console.log(internalstatus);
    if (isFilling) {
      data.externalStatusTypeId = externalStatusTypeId;
      console.log("create");
      return this.http.post<any>(
        this.getEndpoint(
          `ExemptionFilingBasic/StatusData?userId=${userId}`
        ),
        `{ "id": ${requestTypeId}, "externalStatusTypeId": ${externalStatusTypeId}, "internalStatus": ${internalstatus}}`,
        this.gethttpOptions()
      );
    }
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/RequestType?userId=${userId}`
      ),
      `{ "id": ${requestTypeId}, "externalStatusTypeId": ${externalStatusTypeId}, "requestStatusTypeId": ${internalstatus}, "finalApproval": ${isfinalApproval ? true : false} }`,
      this.gethttpOptions()
    );
  }

   updateExternalRequestStatus(requestTypeId: number, externalStatusTypeId: any) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/RequestType`
      ),
      `{ "id": ${requestTypeId}, "externalStatusTypeId": ${externalStatusTypeId}}`,
      this.gethttpOptions()
    );
  }

  assignUserExemptionFilingRequest(requestTypeId: number) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestDetail/AssignedTo?userId=${userId}`
      ),
      `{ "id": ${requestTypeId}, "ApplicationUser": "${encodeURIComponent(userId)}"}`,
      this.gethttpOptions()
    );
  }

  getNotes(id: number, isFilling = false) {
    if(isFilling)
    {
      return this.http.get<any>(
        this.getEndpoint(`ExemptionFilingDetail/${id}/Notes`),
        this.gethttpOptions()
      );
      
    }
    return this.http.get<any>(
      this.getEndpoint(`ExemptionFilingRequestDetail/${id}/Notes`),
      this.gethttpOptions()
    );
  }


  auditData(id: number, isFilling = false) {
    if (isFilling) {
      return of([]);
    }
    var userId = this.getUser().userId;
    return this.http.get<any>(
      this.getEndpoint(`ExemptionFilingRequestBasic/Audit?id=${id}&clearErrorsFirst=true&userId=${userId}`),
      this.gethttpOptions()
    );
  }

  getPrintDoc(id: number, isFilling = false) {
    if (isFilling) {
      return this.http.get<any>(
        this.getEndpoint(`ExemptionFilingBasic/${id}/PrintApplication`),
        {
          headers: this.gethttpOptionsFormDataContent(),
        }
      );
    }
    return this.http.get<any>(
      this.getEndpoint(`ExemptionFilingRequestBasic/${id}/PrintApplication`),
      {
        headers: this.gethttpOptionsFormDataContent(),
      }
    );
  }

  getSummary(id: number, isFilling = false) {
    if (isFilling) {
      return this.http.get<any>(
        this.getEndpoint(`ExemptionFilingDetail/${id}/Summary`),
        this.gethttpOptions()
      );
    }
    return this.http.get<any>(
      this.getEndpoint(`ExemptionFilingRequestDetail/${id}/Summary`),
      this.gethttpOptions()
    );
  }

  addNote(id: number, note: string, isFilling = false) {
    var userId = this.getUser().userId;
    if (isFilling) {
      return this.http.post<any>(
        this.getEndpoint(
          `ExemptionFilingBasic/${id}/Note?userId=${userId}`
        ),
        `{ "note": "${encodeURIComponent(note)}"}`,
        this.gethttpOptions()
      );
    }
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/${id}/Note?userId=${userId}`
      ),
      `{ "note": "${encodeURIComponent(note)}"}`,
      this.gethttpOptions()
    );
  }
  
  saveQualificationTab(data: any) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/QualificationTab?userId=${userId}`
      ),
      data,
      this.gethttpOptions()
    );
  }

  saveRequestVerificationTab(data: any) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/VerificationTab?userId=${userId}`
      ),
      data,
      this.gethttpOptions()
    );
  }
  
  saveEntityInformation(id: any, entityControlNumber: any, fein: any, qualificationTypeId: any) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/EntityInformation?userId=${userId}`
      ),
      `{ "id": ${id}, "entityControlNumber": "${entityControlNumber}", "fein": "${fein}", "qualificationTypeId": ${qualificationTypeId}  }`,
      this.gethttpOptions()
    );
  }
  saveRequestaCopyTab(data: any) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/RequestACopyTab?userId=${userId}`
      ),
      data,
      this.gethttpOptions()
    );
  }
  savePhysicalAddressTab(data: any) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/PhysicalAddressTab?userId=${userId}`
      ),
      data,
      this.gethttpOptions()
    );
  }
  saveMailingAddressTab(data: any) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/MailingAddressTab?userId=${userId}`
      ),
      data,
      this.gethttpOptions()
    );
  }
  saveLicenseTab(data: any) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/LicenseTab?userId=${userId}`
      ),
      data,
      this.gethttpOptions()
    );
  }
  saveSignatureTab(data: any) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/SignatureTab?userId=${userId}`
      ),
      data,
      this.gethttpOptions()
    );
  }

  saveConfirmationInternalTab(data: any){
      var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/ConfirmationTabInternal?userId=${userId}`
      ),
      data,
      this.gethttpOptions())
  };

  saveConfirmationTab(data: any) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestBasic/ConfirmationTab?userId=${userId}`
      ),
      data,
      this.gethttpOptions()
    );
  }
  savePaymentTab(data: any) {
    var userId = this.getUser().userId;
    console.log("Save Payment Tab");
    return this.http.post<any>(
      this.getEndpoint(`PaymentInformationBasic?userId=${userId}`),
      data,
      this.gethttpOptions()
    );
  }

  saveUploadTab(id: any, PaymentAndUploadMode: any) {
    var userId = this.getUser().userId;
    return this.http.post<any>(
      this.getEndpoint(
        `ExemptionFilingRequestDetail/UploadTab`
      ),
      `{ "id": ${id}, "PaymentAndUploadMode": ${PaymentAndUploadMode}  }`,
      this.gethttpOptions()
    );
  }

  getPayments(id: number) {
    var userId = this.getUser().userId;
    return this.http.get<any>(
      this.getEndpoint(
        `PaymentInformationDetail?ExemptionFilingRequestId=${id}`
      ),
      this.gethttpOptions()
    );
  }

  getExemptionAudittDetail(id: number) {
    var userId = this.getUser().userId;
    return this.http.get<any>(
      this.getEndpoint(
        `ExemptionFilingRequestDetail/Audit?id=${id}&userId=${userId}`
      ),
      this.gethttpOptions()
    );
  }

  getHistory(id: number) {
      return this.http.get<any>(
        this.getEndpoint(`ExemptionHistoryDetail?ExemptionFilingId=${id}`),
        this.gethttpOptions()
      );
  }
  getHistoryForRequest(requestid: number, fillingId: number) {
    return this.http.get<any>(
      this.getEndpoint(`ExemptionHistoryDetail?ExemptionFilingId=${fillingId ? fillingId : ''}&ExemptionRequestId=${requestid}&combinedResults=${true}`),
      this.gethttpOptions()
    );
}
}
